import api from './api';

export function getTiposLogradouro() {
  return api.get('tipoLogradouro/public/list');
} 
